import React from 'react';
import { func, bool, string, array, number } from 'prop-types';
import classNames from 'classnames';
import Modal from '../../../../../../../../../../shared/components/Modal';
import AvailableServicesTrigger from '../AvailableServicesTrigger';
import SellerGigs from '../SellerGigs';

import './style.scss';

const AvailableServicesModal = ({ className, gigs, total, loading, onOpen }) => {
    const renderTrigger = ({ open }) => <AvailableServicesTrigger total={total} onClick={open} />;

    return (
        <Modal className={classNames('available-services-modal', className)} trigger={renderTrigger} onOpen={onOpen}>
            <SellerGigs gigs={gigs} loading={loading} total={total} />
        </Modal>
    );
};

AvailableServicesModal.propTypes = {
    className: string,
    gigs: array,
    total: number,
    loading: bool,
    onOpen: func,
};

export default AvailableServicesModal;
